import { useState, useEffect } from "react";

const useLocationEnabled = () => {
  const [isLocationEnabled, setIsLocationEnabled] = useState(true);

  useEffect(() => {
    const checkLocationEnabled = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setIsLocationEnabled(true);
            navigator.permissions
              .query({ name: "geolocation" })
              .then((permissionStatus) => {
                const updateLocationStatus = () => {
                  setIsLocationEnabled(permissionStatus.state === "granted");
                };
                permissionStatus.onchange = updateLocationStatus;
              });
          },
          (error) => {
            console.error("Error checking geolocation permission:", error);
            setIsLocationEnabled(false);
          },
          { maximumAge: 20000, timeout: 20000, enableHighAccuracy: false },
        );
      } else {
        setIsLocationEnabled(false);
      }
    };

    checkLocationEnabled();

    return () => {
      // Cleanup code if needed
    };
  }, []);

  return isLocationEnabled;
};

export default useLocationEnabled;
